module.exports = __webpack_public_path__ + "img/06.9c950d19.png";